export const SOLUTION_FILTERS = [
  "İptal",
  "İade",
  "İtiraz",
  "Şikâyet",
  "Kamu",
  "Dolandırıcılık",
  "KVKK",
  "Seyahat",
];

export const SOLUTIONS = [
  {
    id: "subscription-cancel",
    slug: "abonelik-iptali",
    title: "Aboneliğimi iptal et",
    description: "İnternet, TV, mobil hat ve üyelikler",
    icon: "unplug",
    theme: "mint",
    filters: ["İptal"],
    keywords: ["abonelik", "üyelik", "fesih", "internet iptali", "hat kapatma", "taahhüt"],
    companyGroups: ["telecom", "mobile", "utility", "digital", "other"],
    status: "active",
    issue: "iptal",
    flow: "cancellation",
  },
  {
    id: "refund",
    slug: "para-iadesi",
    title: "Paramı geri al",
    description: "İade edilmeyen ücret ve geri ödemeler",
    icon: "wallet",
    theme: "ice",
    filters: ["İade", "İtiraz"],
    keywords: ["para iadesi", "geri ödeme", "ücret iadesi", "param yatmadı"],
    companyGroups: ["ecommerce", "digital"],
    status: "active",
    issue: "iade",
    flow: "refund",
    entryScreen: "category",
  },
  {
    id: "invoice-objection",
    slug: "fatura-itirazi",
    title: "Faturama itiraz et",
    description: "Yüksek fatura, haksız ücret ve ek bedeller",
    icon: "receipt",
    theme: "sand",
    filters: ["İtiraz", "Şikâyet"],
    keywords: ["fatura", "yüksek fatura", "haksız ücret", "ek bedel", "cayma bedeli"],
    companyGroups: ["telecom", "mobile", "utility", "digital"],
    status: "active",
    issue: "fatura",
    flow: "invoice",
    entryScreen: "category",
  },
  {
    id: "product-service",
    slug: "urun-hizmet-sorunu",
    title: "Ürün veya hizmet sorunum var",
    description: "Bozuk ürün, eksik hizmet ve çözülmeyen sorunlar",
    icon: "wrench",
    theme: "coral",
    filters: ["İade", "Şikâyet"],
    keywords: ["bozuk ürün", "ayıplı ürün", "eksik hizmet", "değişim", "satıcı"],
    companyGroups: ["ecommerce"],
    status: "active",
    issue: "iade",
    flow: "product-service",
    entryScreen: "product-problem",
  },
  {
    id: "order-problem",
    slug: "siparis-sorunu",
    title: "Siparişimle ilgili sorun var",
    description: "Gelmeyen, yanlış veya eksik siparişler",
    icon: "package",
    theme: "lilac",
    filters: ["İade", "Şikâyet"],
    keywords: ["sipariş", "gelmedi", "yanlış ürün", "eksik ürün"],
    companyGroups: ["ecommerce"],
    status: "soon",
    soonText: "Sipariş sorunlarında satıcı ve platforma göre doğru başvuru sırasını ve gerekli belgeleri hazırlıyoruz.",
  },
  {
    id: "cargo",
    slug: "kargo-kayip-hasar",
    title: "Kargom kayıp veya hasarlı",
    description: "Kayıp paket, hasar ve teslimat sorunları",
    icon: "truck",
    theme: "ice",
    filters: ["İade", "Şikâyet"],
    keywords: ["kargo", "paket", "teslimat", "hasarlı", "kayıp", "kargom gelmedi"],
    status: "soon",
    soonText: "Kayıp ve hasarlı kargolar için taşıyıcıya ve satıcıya göre başvuru sırasını hazırlıyoruz.",
  },
  {
    id: "telecom-problem",
    slug: "internet-telefon-tv-sorunu",
    title: "İnternet / telefon / TV sorunum var",
    description: "Kesinti, hız, taahhüt ve cayma bedeli",
    icon: "wifi",
    theme: "mint",
    filters: ["İtiraz", "Şikâyet"],
    keywords: ["internet", "telefon", "tv", "kesinti", "hız", "taahhüt", "cayma"],
    companyGroups: ["telecom", "mobile"],
    status: "active",
    entryScreen: "telecom-gate",
  },
  {
    id: "bank-card",
    slug: "banka-kart-itirazi",
    title: "Banka veya kart işlemine itiraz et",
    description: "Haksız çekim, aidat, ATM ve ödeme sorunları",
    icon: "credit-card",
    theme: "sand",
    filters: ["İtiraz", "Dolandırıcılık"],
    keywords: ["banka", "kart", "aidat", "atm", "ödeme", "çekim"],
    status: "soon",
    soonText: "Banka ve kart işlemleri için doğru başvuru sırasını, gerekli belgeleri ve hazır başvuru metinlerini hazırlıyoruz.",
  },
  {
    id: "fraud",
    slug: "dolandiricilik",
    title: "Dolandırıldım",
    description: "İlk yapılacakları ve başvuru sırasını öğrenin",
    icon: "shield-alert",
    theme: "coral",
    filters: ["Dolandırıcılık", "Şikâyet"],
    keywords: ["dolandırıldım", "sahte", "şüpheli işlem", "hesabım çalındı"],
    status: "soon",
    soonText: "Dolandırıcılık şüphesinde ilk yapılacakları ve ilgili kurumlara güvenli başvuru sırasını hazırlıyoruz.",
  },
  {
    id: "travel",
    slug: "seyahat-sorunu",
    title: "Uçuşum veya yolculuğum aksadı",
    description: "Bilet, iptal, bagaj ve rezervasyon sorunları",
    icon: "plane",
    theme: "ice",
    filters: ["Seyahat", "İade", "Şikâyet"],
    keywords: ["uçuş", "bilet", "bagaj", "rezervasyon", "otel", "seyahat"],
    status: "soon",
    soonText: "Uçuş ve yolculuk sorunlarında işletmeye ve olay türüne göre haklarınızı ve başvuru yolunu hazırlıyoruz.",
  },
  {
    id: "service-warranty",
    slug: "servis-garanti-sorunu",
    title: "Ürün bozuk, servis çözmüyor",
    description: "Garanti, tamir, değişim ve servis işlemleri",
    icon: "badge-check",
    theme: "lilac",
    filters: ["İade", "Şikâyet"],
    keywords: ["garanti", "servis", "tamir", "değişim", "bozuk ürün", "ayıplı"],
    companyGroups: ["ecommerce"],
    status: "active",
    issue: "iade",
    flow: "product-service",
    entryScreen: "product-problem",
    preset: "defective",
  },
  {
    id: "insurance",
    slug: "sigorta-bes-sorunu",
    title: "Sigorta veya BES sorunum var",
    description: "Poliçe, hasar ödemesi, tazminat ve ayrılma",
    icon: "umbrella",
    theme: "mint",
    filters: ["İtiraz", "Şikâyet"],
    keywords: ["sigorta", "bes", "poliçe", "tazminat", "hasar"],
    status: "soon",
    soonText: "Sigorta ve BES işlemleri için ürün türüne göre başvuru ve itiraz yollarını hazırlıyoruz.",
  },
  {
    id: "utilities",
    slug: "elektrik-su-dogalgaz-sorunu",
    title: "Elektrik / su / doğalgaz sorunum var",
    description: "Fatura, sayaç, kesinti ve abonelik işlemleri",
    icon: "zap",
    theme: "sand",
    filters: ["İptal", "İtiraz", "Şikâyet"],
    keywords: ["elektrik", "su", "doğalgaz", "sayaç", "kesinti", "abonelik"],
    companyGroups: ["utility"],
    status: "soon",
    soonText: "Temel hizmetlerde fatura, sayaç ve kesinti sorunları için kuruma göre başvuru yollarını hazırlıyoruz.",
  },
  {
    id: "marketing",
    slug: "reklam-sms-aramalari",
    title: "Reklam SMS ve aramalarını durdur",
    description: "İzinsiz mesaj ve pazarlama aramaları",
    icon: "message-off",
    theme: "coral",
    filters: ["KVKK", "Şikâyet"],
    keywords: ["reklam", "sms", "arama", "istenmeyen mesaj", "pazarlama"],
    status: "soon",
    soonText: "İzinsiz ticari iletişimler için ret ve şikâyet adımlarını tek bir akışta hazırlıyoruz.",
  },
  {
    id: "data-delete",
    slug: "veri-silme-hesap-kapatma",
    title: "Verilerimi sildir veya hesabımı kapat",
    description: "KVKK, veri silme ve hesap kapatma başvuruları",
    icon: "user-x",
    theme: "lilac",
    filters: ["KVKK", "İptal"],
    keywords: ["kvkk", "veri silme", "hesap kapatma", "kişisel veri"],
    status: "soon",
    soonText: "Veri silme ve hesap kapatma talepleri için KVKK uyumlu başvuru adımlarını hazırlıyoruz.",
  },
  {
    id: "public-application",
    slug: "cimer-kamu-basvurusu",
    title: "CİMER veya kamu başvurusu hazırla",
    description: "Kuruma başvuru ve cevap alamama sorunları",
    icon: "landmark",
    theme: "ice",
    filters: ["Kamu", "Şikâyet"],
    keywords: ["cimer", "kamu", "devlet", "kurum", "cevap alamadım"],
    status: "soon",
    soonText: "Kamu kurumlarına yapılacak başvurular için doğru kurum ve metin yapısını hazırlıyoruz.",
  },
  {
    id: "municipality",
    slug: "belediye-sorunu",
    title: "Belediyeyle ilgili sorun var",
    description: "Altyapı, çevre, ruhsat ve yerel hizmetler",
    icon: "building",
    theme: "mint",
    filters: ["Kamu", "Şikâyet"],
    keywords: ["belediye", "altyapı", "çevre", "ruhsat", "yerel hizmet"],
    status: "soon",
    soonText: "Belediye ve yerel hizmet sorunlarında birime göre başvuru yolunu hazırlıyoruz.",
  },
  {
    id: "deposit",
    slug: "depozito-iadesi",
    title: "Depozitomu geri al",
    description: "Kiralama, taşınma ve site yönetimi sorunları",
    icon: "key-round",
    theme: "sand",
    filters: ["İade", "İtiraz"],
    keywords: ["depozito", "kira", "kiralama", "taşınma", "site yönetimi"],
    status: "soon",
    soonText: "Depozito iadelerinde sözleşme ve teslim durumuna göre başvuru adımlarını hazırlıyoruz.",
  },
  {
    id: "vehicle-fine",
    slug: "hgs-otopark-arac-cezasi",
    title: "HGS / otopark / araç cezasına itiraz et",
    description: "Hatalı geçiş, ceza, otopark ve servis sorunları",
    icon: "car-front",
    theme: "coral",
    filters: ["İtiraz", "Kamu"],
    keywords: ["hgs", "otopark", "araç", "ceza", "hatalı geçiş"],
    status: "soon",
    soonText: "Araç, geçiş ve otopark cezalarında işlem türüne göre itiraz yollarını hazırlıyoruz.",
  },
  {
    id: "work-sgk",
    slug: "is-sgk-sorunu",
    title: "İş veya SGK sorunumu çöz",
    description: "Prim, ücret, çıkış kodu ve çalışma kayıtları",
    icon: "briefcase-business",
    theme: "lilac",
    filters: ["Kamu", "İtiraz", "Şikâyet"],
    keywords: ["iş", "sgk", "prim", "maaş", "ücret", "çıkış kodu"],
    status: "soon",
    soonText: "İş ve SGK sorunlarında ilgili kayıtları ve başvuru sırasını hazırlıyoruz.",
  },
];

export function normalizeSearchText(value) {
  return String(value || "")
    .toLocaleLowerCase("tr")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ı/g, "i");
}
